import { getCustomerProfilUrl } from "../../api/customersBackendEndpoints/customersBackendEndpoints";
import CustomerProfilRepository from "@/core/customers/repositories/CustomerProfilRepository";
import { CustomerProfilResponse } from "@/core/customers/entities";
import { ApiResponse } from "../../api/types/ApiResponse";
import { ApiResponseHandler } from "../../http/services/handleApiResponse/handleApiResponse";
import { HttpClient } from "../../http/HttpClient";

// src/infrastructure/customers/CustomerProfilRepositoryBackend.ts
export default class CustomerProfilRepositoryBackend
  implements CustomerProfilRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  getCustomerProfil(businessKey: string): Promise<CustomerProfilResponse> {
    return this.httpClient
      .get<ApiResponse<CustomerProfilResponse["data"]>>({
        url: getCustomerProfilUrl(businessKey),
        withAuth: true,
      })
      .then((response) => {
        const result = ApiResponseHandler.handleResponse(response);
        if (!result.success) {
          throw ApiResponseHandler.createExceptionFromResponse(response);
        }
        return {
          code: response.code,
          message: response.message,
          data: response.data,
        } as CustomerProfilResponse;
      });
  }
}
